import { render, staticRenderFns } from "./ArchiveCaseListItem.vue?vue&type=template&id=4be4f36b&scoped=true&"
import script from "./ArchiveCaseListItem.vue?vue&type=script&lang=ts&"
export * from "./ArchiveCaseListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveCaseListItem.vue?vue&type=style&index=0&id=4be4f36b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4f36b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VListItem,VListItemAction,VListItemContent,VRow,VSpacer})
